// import { IConsignerOnboardRenderingConfig } from '@fareye/settings'
import environment from '../../environment'

let { baseURL: baseUrl } = environment
//baseUrl = 'http://localhost:3001'

export const ConsignerOnboardRenderingConfig: any = {
  config: {},
  styling: {},
  children: {
    listChildUser: {
      label: 'Onboard Consigner List',
      config: {
        children: {
          listChildUser: {
            apiConfig: {
              listChildUser: {
                apiUrl: `${baseUrl}/api/v3/admin/onboarding/users`
              }
            },
            selectedColumns: [
              'name',
              'email',
              'primaryPhoneNo',
              'state',
              'action'
            ]
          },
          addChildUser: {
            apiConfig: {
              addChildUser: {
                apiUrl: `${baseUrl}/api/v3/admin/onboarding/users`
              }
            },
            formRenderingConfig: {
              label: 'Onboard Consigner',
              formKey: 'addChildUser',
              options: {},
              desc: 'Use this form to onboard Consigner',

              styles: {},
              formConfig: {
                '1': {
                  data: [
                    {
                      formKey: 'account-details-heading',
                      validation: null,
                      label: 'Account Details',
                      type: 'heading',
                      row: 1,
                      styling: {
                        variant: { width: [1] },
                        styles: {
                          fontSize: '15px',
                          fontWeight: 'bold',
                          marginBottom: '16px',
                          paddingBottom: '8px',
                          borderBottom: '1px solid #e0e0e0',
                          color: '#333'
                        }
                      },
                      dependency: null,
                      options: null
                    }
                  ]
                },
                '2': {
                  data: [
                    {
                      formKey: 'consigner-userAttributes-firstName',
                      validation: 'required',
                      label: 'First Name*',
                      type: 'text',
                      placeholder: 'Enter First name',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'consigner-userAttributes-lastName',
                      validation: 'required',
                      label: 'Last Name*',
                      type: 'text',
                      placeholder: 'Enter Last Name',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'consigner-userAttributes-email',
                      validation: 'email',
                      label: 'Email*',
                      type: 'text',
                      placeholder: 'Enter email',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'consigner-userAttributes-primaryPhoneNo',
                      validation: 'phone',
                      label: 'Phone No*',
                      type: 'number',
                      placeholder: 'Enter Phone No.',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'consigner-userAttributes-password',
                      validation: 'required',
                      label: 'Password*',
                      type: 'password',
                      placeholder: 'Enter Password',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: {tooltip: 'Rules: Minimum 10 Characters , 2 Upper Case , 2 Lower Case , 1 Special Character [!@*]'},
                      desc: 'Minimum 10 Characters , 2 Upper Case , 2 Lower Case , 1 Special Character [!@*]'
                    }
                  ],
                  style: {}
                },
                '3': {
                  data: [
                    {
                      formKey: 'consigner-userAttributes-passwordConfirmation',
                      validation: 'required',
                      label: 'Confirmed Password*',
                      type: 'password',
                      placeholder: 'Enter Confirmed Password',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: {tooltip: 'Rules: Minimum 10 Characters , 2 Upper Case , 2 Lower Case , 1 Special Character [!@*]'},
                      desc: 'Minimum 10 Characters , 2 Upper Case , 2 Lower Case , 1 Special Character [!@*]'
                    },
                    {
                      formKey: 'consigner-userAttributes-state',
                      validation: null,
                      label: 'Account status*',
                      type: 'select',
                      placeholder: 'Select',
                      options: [
                        {
                          value: 'active',
                          label: 'Active'
                        },
                        {
                          value: 'inactive',
                          label: 'InActive'
                        }
                      ],
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      isMulti: false,
                      row: 1,
                      styles: {},
                      dependency: null
                    },
                    {
                      formKey: 'consigner-userAttributes-userTimezone',
                      validation: null,
                      label: 'User Timezone*',
                      type: 'local-select',
                      placeholder: 'Select',
                      isMulti: false,
                      labelForDisplay: 'label',
                      valueForDisplay: 'value',
                      apiUrl: '/api/v1/timezones',
                      options: null,
                      dependency: null,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      searchQueryKey: 'timezones'
                    },
                    {
                      formKey: 'consigner-userAttributes-language',
                      validation: null,
                      label: 'Select Language',
                      type: 'local-select',
                      placeholder: 'Select',
                      isMulti: false,
                      labelForDisplay: 'label',
                      valueForDisplay: 'value',
                      apiUrl:
                        '/api/v3/admin/onboarding/users/get_language_list',
                      options: null,
                      dependency: null,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      searchQueryKey: 'languages'
                    },
                    {
                      formKey: 'consigner-fareyeInternalUrl',
                      validation: 'url',
                      label: 'Fareye Internal URL',
                      type: 'text',
                      placeholder: 'Enter Fareye Internal URL',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    }
                  ],
                  style: {}
                },
                '4': {
                  data: [
                    {
                      formKey: 'consigner-details-heading',
                      validation: null,
                      label: 'Consigner Details',
                      type: 'heading',
                      row: 1,
                      styling: {
                        variant: { width: [1] },
                        styles: {
                          fontSize: '15px',
                          fontWeight: 'bold',
                          marginBottom: '16px',
                          paddingBottom: '8px',
                          borderBottom: '1px solid #e0e0e0',
                          color: '#333'
                        }
                      },
                      dependency: null,
                      options: null
                    }
                  ]
                },
                '5': {
                  data: [
                    {
                      formKey: 'consigner-consignerName',
                      validation: 'required',
                      label: 'Consigner Name*',
                      type: 'text',
                      placeholder: 'Enter Consigner name',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'consigner-consignerCode',
                      validation: 'required',
                      label: 'Consigner Code*',
                      type: 'text',
                      placeholder: 'Enter Consigner Code',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: {tooltip: 'Rules: Alphanumeric characters only (A-Z, 0-9). No spaces or special characters allowed'},
                      desc: 'Alphanumeric characters only (A-Z, 0-9). No spaces or special characters allowed'
                    },
                    {
                      formKey: 'consigner-consignerPhoneNo',
                      validation: 'phone',
                      label: 'Consigner Phone No*',
                      type: 'number',
                      placeholder: 'Enter Phone No.',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'consigner-consignerAddress',
                      validation: 'required',
                      label: 'Consigner Address*',
                      type: 'text',
                      placeholder: 'Enter Consigner Address',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'consigner-country',
                      validation: null,
                      label: 'Country*',
                      type: 'local-select',
                      placeholder: 'Select',
                      isMulti: false,
                      labelForDisplay: 'label',
                      valueForDisplay: 'value',
                      apiUrl: undefined,
                      options: null,
                      dependency: null,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      searchQueryKey: 'country'
                    }
                  ],
                  style: {}
                },
                '6': {
                  data: [
                    {
                      formKey: 'consigner-state',
                      validation: null,
                      label: 'State*',
                      type: 'local-select',
                      placeholder: 'Select',
                      isMulti: false,
                      labelForDisplay: 'label',
                      valueForDisplay: 'value',
                      apiUrl:
                        '/api/v3/admin/get_state',
                      options: null,
                      dependency: null,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      searchQueryKey: 'states'
                    },
                    {
                      formKey: 'consigner-city',
                      validation: 'required',
                      label: 'City*',
                      type: 'text',
                      placeholder: 'City',
                      // City dropdown New Delhi, Noida
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      isMulti: false,
                      row: 1,
                      styles: {},
                      dependency: null
                    },
                    {
                      formKey: 'consigner-forceClosureDays',
                      validation: null,
                      label: 'Trip force closure days',
                      type: 'number',
                      placeholder: 'Enter days.',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: {tooltip: 'Trips will be forcefully closed after X number of days.'},
                      desc: 'Trips will be forcefully closed after X number of days.'
                    },
                    {
                        formKey: 'consigner-replicateFrom',
                        validation: null,
                        label:"Demo Replicate Account",
                        type: 'local-select',
                        placeholder: 'Select',
                        isMulti: false,
                        labelForDisplay: 'consigner_name',
                        valueForDisplay: 'id',
                        apiUrl:
                          '/api/v3/admin/onboarding/users/get_replicable_data',
                        options: {tooltip: 'Select account to replicate data from'},
                        desc: 'Select account to replicate data from',
                        dependency: null,
                        styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                        searchQueryKey: 'consigners'
                      }
                  ],
                  style: {}
                },
                '7': {
                  data: [
                    {
                      formKey: 'consigner-isJourneyModel',
                      validation: null,
                      label: 'is journey model?',
                      type: 'checkbox',
                      placeholder: '',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'consigner-userAttributes-timeFmt24Hr',
                      validation: null,
                      label: 'Follows 24 hrs format',
                      type: 'checkbox',
                      placeholder: '',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'consigner-userAttributes-useOauth2',
                      validation: null,
                      label: 'Use Common Oauth?',
                      type: 'checkbox',
                      placeholder: '',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'consigner-demoAccount',
                      validation: null,
                      label: 'Is demo account?',
                      type: 'checkbox',
                      placeholder: '',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'consigner-replicateData',
                      validation: null,
                      label: 'Want to replicate data?',
                      type: 'checkbox',
                      placeholder: '',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    }
                  ],
                  style: {}
                },
                '8': {
                  data: [
                    {
                      formKey: 'consigner-userAttributes-feEmail',
                      validation: null,
                      label: 'FE Email',
                      type: 'text',
                      placeholder: 'Enter FE Email',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'consigner-userAttributes-feUsername',
                      validation: null,
                      label: 'FE Username*',
                      type: 'text',
                      placeholder: 'Enter FE Username',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: {tooltip: 'Same as Mobi username'},
                      desc: 'Same as Mobi username'
                    },
                    {
                      formKey: 'consigner-userAttributes-userCode',
                      validation: null,
                      label: 'Company Code*',
                      type: 'text',
                      placeholder: 'Enter Company Code',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: {tooltip: 'Same as Mobi'},
                      desc: 'Same as Mobi'
                    }
                  ],
                  style: {}
                }
              },
              btnConfig: {
                submitButton: {
                  label: 'Submit',
                  style: {},
                  isDisplay: true
                },
                resetButton: {
                  isDisplay: true,
                  label: 'Reset',
                  style: {}
                }
              }
            }
          },
          editChildUser: {
            apiConfig: {
              editChildUser: {
                apiUrl: `${baseUrl}/api/v3/admin/onboarding/users`
              }
            },
            formRenderingConfig: {
              label: 'Edit Consigner',
              formKey: 'editChildUser',
              options: {},
              desc: 'Used this form to Edit Consigner details',

              styles: {},
              formConfig: {
                '1': {
                  data: [
                    {
                      formKey: 'account-details-heading-edit',
                      validation: null,
                      label: 'Account Details',
                      type: 'heading',
                      row: 1,
                      styling: {
                        variant: { width: [1] },
                        styles: {
                          fontSize: '15px',
                          fontWeight: 'bold',
                          marginBottom: '16px',
                          paddingBottom: '8px',
                          borderBottom: '1px solid #e0e0e0',
                          color: '#333'
                        }
                      },
                      dependency: null,
                      options: null
                    }
                  ]
                },
                '2': {
                  data: [
                    {
                      formKey: 'firstName',
                      validation: 'required',
                      label: 'First Name*',
                      type: 'text',
                      placeholder: 'Enter First name',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'lastName',
                      validation: 'required',
                      label: 'Last Name*',
                      type: 'text',
                      placeholder: 'Enter Last Name',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'email',
                      validation: 'email',
                      label: 'Email*',
                      type: 'text',
                      placeholder: 'Enter email',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'primaryPhoneNo',
                      validation: 'phone',
                      label: 'Phone No*',
                      type: 'number',
                      placeholder: 'Enter Phone No.',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'password',
                      label: 'Password*',
                      type: 'password',
                      placeholder: 'Enter Password',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: {tooltip: 'Rules: Minimum 10 Characters , 2 Upper Case , 2 Lower Case , 1 Special Character [!@*]'},
                      desc: 'Minimum 10 Characters , 2 Upper Case , 2 Lower Case , 1 Special Character [!@*]'
                    }
                  ],
                  style: {}
                },
                '3': {
                  data: [
                    {
                      formKey: 'passwordConfirmation',
                      label: 'Confirmed Password*',
                      type: 'password',
                      placeholder: 'Enter Confirmed Password',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: {tooltip: 'Rules: Minimum 10 Characters , 2 Upper Case , 2 Lower Case , 1 Special Character [!@*]'},
                      desc: 'Minimum 10 Characters , 2 Upper Case , 2 Lower Case , 1 Special Character [!@*]'
                    },
                    {
                      formKey: 'state',
                      validation: null,
                      label: 'Account status*',
                      type: 'select',
                      placeholder: 'Select',
                      options: [
                        {
                          value: 'active',
                          label: 'Active'
                        },
                        {
                          value: 'inactive',
                          label: 'InActive'
                        }
                      ],
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      isMulti: false,
                      row: 1,
                      styles: {},
                      dependency: null
                    },
                    {
                      formKey: 'userTimezone',
                      validation: 'required',
                      label: 'User Timezone*',
                      type: 'local-select',
                      placeholder: 'Select',
                      isMulti: false,
                      labelForDisplay: 'label',
                      valueForDisplay: 'value',
                      apiUrl: '/api/v1/timezones',
                      options: null,
                      dependency: null,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      searchQueryKey: 'timezones'
                    },
                    {
                      formKey: 'language',
                      validation: null,
                      label: 'Select Language',
                      type: 'local-select',
                      placeholder: 'Select',
                      isMulti: false,
                      labelForDisplay: 'label',
                      valueForDisplay: 'value',
                      apiUrl:
                        '/api/v3/admin/onboarding/users/get_language_list',
                      options: null,
                      dependency: null,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      searchQueryKey: 'languages'
                    },
                    {
                      formKey: 'fareyeInternalUrl',
                      validation: 'url',
                      label: 'Fareye Internal URL',
                      type: 'text',
                      placeholder: 'Enter Fareye Internal URL',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    }
                  ],
                  style: {}
                },
                '4': {
                  data: [
                    {
                      formKey: 'consigner-details-heading-edit',
                      validation: null,
                      label: 'Consigner Details',
                      type: 'heading',
                      row: 1,
                      styling: {
                        variant: { width: [1] },
                        styles: {
                          fontSize: '15px',
                          fontWeight: 'bold',
                          marginBottom: '16px',
                          paddingBottom: '8px',
                          borderBottom: '1px solid #e0e0e0',
                          color: '#333'
                        }
                      },
                      dependency: null,
                      options: null
                    }
                  ]
                },
                '5': {
                  data: [
                    {
                      formKey: 'consignerName',
                      label: 'Consigner Name*',
                      type: 'text',
                      placeholder: 'Enter Consigner name',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null,
                    },
                    {
                      formKey: 'consignerCode',
                      label: 'Consigner Code*',
                      type: 'text',
                      placeholder: 'Enter Consigner Code',
                      // Dropdown
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: {tooltip: 'Rules: Alphanumeric characters only (A-Z, 0-9). No spaces or special characters allowed'},
                      desc: 'Alphanumeric characters only (A-Z, 0-9). No spaces or special characters allowed'
                    },
                    {
                      formKey: 'consignerPhoneNo',
                      validation: 'phone',
                      label: 'Consigner Phone No*',
                      type: 'number',
                      placeholder: 'Enter Phone No.',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null,
                    },
                    {
                      formKey: 'consignerAddress',
                      label: 'Consigner Address*',
                      type: 'text',
                      placeholder: 'Enter Consigner Address',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null,
                    },
                    {
                      formKey: 'countryLocal',
                      validation: null,
                      label: 'Country*',
                      type: 'local-select',
                      placeholder: 'Select',
                      isMulti: false,
                      labelForDisplay: 'label',
                      valueForDisplay: 'value',
                      apiUrl: '',
                      options: null,
                      dependency: null,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      searchQueryKey: 'country'
                    }
                  ],
                  style: {}
                },
                '6': {
                  data: [
                    {
                      formKey: 'stateLocal',
                      validation: null,
                      label: 'State*',
                      type: 'local-select',
                      placeholder: 'Select',
                      isMulti: false,
                      labelForDisplay: 'label',
                      valueForDisplay: 'value',
                      apiUrl: '',
                      options: null,
                      dependency: null,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      searchQueryKey: 'states'
                    },
                    {
                      formKey: 'city',
                      label: 'City*',
                      type: 'text',
                      placeholder: 'City',
                      // City dropdown New Delhi, Noida
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      isMulti: false,
                      row: 1,
                      styles: {},
                      dependency: null
                    },
                    {
                      formKey: 'forceClosureDays',
                      validation: null,
                      label: 'Trip force closure days',
                      type: 'number',
                      placeholder: 'Enter days.',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: {tooltip: 'Trips will be forcefully closed after X number of days.'},
                      desc: 'Trips will be forcefully closed after X number of days.'
                    },
                    {
                        formKey: 'replicateFrom',
                        validation: null,
                        label:"Demo Replicate Account",
                        type: 'local-select',
                        placeholder: 'Select',
                        isMulti: false,
                        labelForDisplay: 'consigner_name',
                        valueForDisplay: 'id',
                        apiUrl:
                          '/api/v3/admin/onboarding/users/get_replicable_data',
                        options: {tooltip: 'Select account to replicate data from'},
                        desc: 'Select account to replicate data from',
                        dependency: null,
                        styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                        searchQueryKey: 'consigners'
                      }
                  ],
                  style: {}
                },
                '7': {
                  data: [
                    {
                      formKey: 'isJourneyModel',
                      validation: null,
                      label: 'is journey model?',
                      type: 'checkbox',
                      placeholder: '',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null,
                    },
                    {
                      formKey: 'timeFmt24Hr',
                      validation: null,
                      label: 'Follows 24 hrs format',
                      type: 'checkbox',
                      placeholder: '',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'useOauth2',
                      validation: null,
                      label: 'Use Common Oauth?',
                      type: 'checkbox',
                      placeholder: '',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null,
                    },
                    {
                      formKey: 'demoAccount',
                      validation: null,
                      label: 'Is demo account?',
                      type: 'checkbox',
                      placeholder: '',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null,
                    },
                    {
                      formKey: 'replicateData',
                      validation: null,
                      label: 'Want to replicate data?',
                      type: 'checkbox',
                      placeholder: '',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null,
                    }
                  ],
                  style: {}
                },
                '8': {
                  data: [
                    {
                      formKey: 'feEmail',
                      validation: null,
                      label: 'FE Email',
                      type: 'text',
                      placeholder: 'Enter FE Email',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: null
                    },
                    {
                      formKey: 'feUsername',
                      validation: null,
                      label: 'FE Username*',
                      type: 'text',
                      placeholder: 'Enter FE Username',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: {tooltip: 'Same as Mobi username'},
                      desc: 'Same as Mobi username'
                    },
                    {
                      formKey: 'userCode',
                      validation: null,
                      label: 'Company Code*',
                      type: 'text',
                      placeholder: 'Enter Company Code',
                      row: 1,
                      styling: { variant: { width: [1, 1 / 2, 1 / 5] } },
                      dependency: null,
                      options: {tooltip: 'Same as Mobi'},
                      desc: 'Same as Mobi'
                    }
                  ],
                  style: {}
                }
              },
              btnConfig: {
                submitButton: {
                  label: 'Update',
                  style: {},
                  isDisplay: true
                },
                resetButton: {
                  isDisplay: true,
                  label: 'Reset',
                  style: {}
                }
              }
            }
          }
        }
      },
      id: 'listChildUser',
      styling: {
        bodyBgColor: '#F0F2F5',
        style: {
          padding: '0px',
          width: '100%',
          overflow: 'hidden',
          boxShadow: 'inset 0px 5px 10px -5px rgba(239,239,239,1)'
        },
        className: '',
        variant: {
          gridGap: '5px'
        }
      }
    }
  },
  baseUrl: baseUrl
}
